module.exports = __webpack_public_path__ + "static/media/apple-header.73d19a2c.jpg";